// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logo {\r\n  max-width: 300px; /* Adjust the max-width of the logos as needed */\n}\r\n", ""]);
// Exports
module.exports = exports;
